import { ROUTES } from "@/route/routes.constants";
import { useAppSelector } from "@/store/hooks";
import { FC, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router";

interface WithNoAuthProps {
  children: ReactNode;
}

export const WithNoAuth: FC<WithNoAuthProps> = ({ children }) => {
  const token = useAppSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate(ROUTES.INSPECTIONS);
    }
  }, [navigate, token]);

  return <>{children}</>;
};

